import React, {useEffect, useRef, useState} from "react";
import socket from "../utils/clientSocket";
import "../App.css";
import "./CreateGameModal";
import AcceptDenyModal from "./AcceptDenyModal";
import LobbyCard from "./LobbyCard";

const Lobby = () => {
    const [globalLobby, setGlobalLobby] = useState([]);

    const [ownGameOffer, setOwnGameOffer] = useState(null)
    //This may seem like double work - but the state variable is only updated during rerender, so the ref is used
    //to ensure it is always exactly up to date when filtering otherOffers
    const ownOfferId = useRef(null)
    const [showCancelOffer, setShowCancelOffer] = useState(false)

    //This may also seem like double work, but the ref guarantees we are looking at something up to date
    const acceptedOfferIds = useRef([])


    //TODO change this back to only using a global lobby
    useEffect(() => {
        socket.on("updateLobby", ({roomUid, offers}) => {
            const otherOffers = offers.filter((o) => o.offerId !== ownOfferId.current);
            if(roomUid === "global") {
                //It looks weird - but I think as long as we use method state updates they are queued sequentially,
                //which is important for the filtering in the offerCreated event handler
                setGlobalLobby((prevState) => otherOffers);
            }});

        socket.on("offerCreated", (offer) => {
            setOwnGameOffer(offer)
            ownOfferId.current = offer.offerId

            //We can often get the updateLobby event before the offerCreated - in that case ensure the offer from update lobby
            //is filtered afterwards
            setGlobalLobby((prevState) => prevState.filter((o) => o.offerId !== ownOfferId.current))
        })

        return () => {
            socket.off("updateLobby");
        };
    }, []);

    const handleAcceptGame = (offer) => {
        if(acceptedOfferIds.current.find(a => a === offer.offerId)) {
            console.log("offer already accepted")
            return;
        }
        acceptedOfferIds.current.push(offer.offerId)
        socket.emit("acceptGameOffer", { offerId: offer.offerId });
        setGlobalLobby((prevState) => prevState.filter(o => o.offerId !== offer.offerId))
    };

    const cancelOffer = () => {
        socket.emit("cancelOffer");
        setShowCancelOffer(false);
        setOwnGameOffer(null);
    }

    return (
        globalLobby.length === 0 && !ownGameOffer ? (
            <p>No offers available</p>
        ) : (
            <div>
                {showCancelOffer && <div className="modal-overlay" onClick={() => setShowCancelOffer(false)}>
                    <AcceptDenyModal statement={"Do you want to cancel your offer?"}
                                     denyCallback={() => setShowCancelOffer(false)}
                                     acceptCallback={cancelOffer} closeCallback={() => setShowCancelOffer(false)}/>

                </div>}
                {ownGameOffer && <LobbyCard offer={ownGameOffer} onClick={() => setShowCancelOffer(true)} style={{backgroundColor: "#bbb"}} isOwnOffer={true}/>}
                {globalLobby.map((offer) => (
                    <LobbyCard offer={offer} onClick={() => handleAcceptGame(offer)} isOwnOffer={false}/>
                ))}
            </div>
        )
    );

};

export default Lobby;



